import "./mod-slot-preview.scss";
import React from "react";
import { LocalCharacterInitializer } from "../../../../../../../entities/characters/Character";
import { ModSlot } from "../../../../../../../entities/library/items/mods/ModSlot";
import { DeleteIcon } from "../../../../../../icons";
import { Loader } from "../../../../../../theming/loader/Loader";
import { useAppDispatch, useAppSelector } from "../../../../../../../store/configureStore";
import { CharacterSpecificActions } from "../../../../../../../store/stores/collection/characters/actions/CharacterSpecificActions";
import { OwnedItemReference } from "../../../../../../../entities/Ownership";
import { ItemHelpers } from "../../../../../../../entities/library/items/Item";
import { CharacterItemActions } from "../../../../../../../store/stores/collection/characters/actions/CharacterItemActions";
import { GetSheetSlots } from "../ItemPreviewSlots";

type Props = {
    character?: LocalCharacterInitializer;
    reference?: OwnedItemReference;
    slot: ModSlot;
    editable?: boolean;
    custom?: boolean;
}

export const ModSlotPreview = (props: Props) => {
    const { character, reference, slot, editable, custom } = props;
    const dispatch = useAppDispatch();

    const allItems = useAppSelector(app => app.library.items);

    const modReference = character?.activeMods.first(m => m.assignedSlotId == slot.id) ?? undefined;
        
    const itemSaved = reference != null && character?.pendingProperties[reference.instanceId] == undefined;
    const modSaved = modReference == null || character?.pendingProperties[modReference.instanceId] == undefined;

    const mod = allItems.find(i => i.id == modReference?.id);
    const isNested = reference != null && ItemHelpers.isMod(reference);

    const canDelete = editable && character && modReference != null;
    const deleteMod = () => {
        dispatch(CharacterItemActions.removeMod(character!, reference!.instanceId, modReference!.instanceId));
    }

    const onClick = () => {
        if (character != null && reference != null && itemSaved && editable) {
            dispatch(CharacterSpecificActions.setPreviewSlot(character, slot.id, reference.instanceId))
        }
    }

    const nestedSlots = mod != null
        ? GetSheetSlots({ ...props, reference: modReference, item: mod })
        : undefined;
    return (
        <>
            <div className={`sheet-slot ${custom ? "custom-slot" : ""} ${itemSaved ? 'editable' : 'not-editable'} ${modSaved ? 'enabled' : 'disabled'} ${isNested ? 'nested-slot' : ''}`}>
                <div className="text bottom">
                    {mod?.name ?? "Empty"}
                    {canDelete && (
                        <button className="delete-button" onClick={deleteMod} disabled={!modSaved}>
                            {modSaved && <DeleteIcon />}
                            {!modSaved && <Loader size="S" />}
                        </button>
                    )}
                </div>
                {(itemSaved || !editable) && 
                    <button className="slot-box interactable-button" onClick={onClick} disabled={!editable || !modSaved}>
                        {mod != null ? ItemHelpers.getIcon(mod) : "+"}
                    </button>
                }
                {!itemSaved && editable &&
                    <button className="slot-box">
                        <Loader />
                    </button>
                }
                <div className="text top">
                    {slot.slotTypes.join(", ")}
                </div>
            </div>
            {nestedSlots}
        </>
    );
}